import { AddCircle, Clear, Delete, Search } from "@mui/icons-material";
import { Box, Card, CardContent, Grid } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortDirection, GridSortModel } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";

import AutoComplete from "../../../components/hookForms/autoComplete";
import { Button } from "@mui/material";
import ConfirmationDialog from "../../../components/confirmationDialog";
import { Container } from "../../../theme/globalStyles";
import DataTable from "../../../components/dataTable";
import DialogNew from "./modal/dialogNew";
import Tooltip from "@mui/material/Tooltip";
import messages from "../../../utils/messages";
import serviceGrupoAlarme from "../../../services/serviceGrupoAlarme";
import serviceUsuario from "@/services/serviceUsuario";
import { toast } from "react-toastify";
/* eslint-disable react-hooks/exhaustive-deps */
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";

const GrupoAlarme = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Alarmes - Grupos de Alarmes");
    }, [setTitlePage]);

    const [data, setData] = useState<any[]>([]);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [filters, setFilters] = useState(null);
    const [rowCount, setRowCount] = useState(0);
    const [isLoading, setLoading] = useState(false);
    const [openNew, setOpenNew] = useState(false);
    const [usersDataOptions, setUsersDataOptions] = useState<any[]>([]);
    const [tipoDataOptions, setTipoDataOptions] = useState<any[]>([]);

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
            field: "",
            sort: "" as GridSortDirection,
        },
    ]);

    const [exclusionState, setExclusionState] = useState({
        data: "",
        open: false,
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            tipoAlarmeID: "",
            usuarioID: "",
            usuariosOcultos: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 170,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Excluir">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => setExclusionState({ data: params.id.toString(), open: true })}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "ID",
                field: "grupoAlarmeID",
                type: "number",
                headerAlign: "left",
                identity: true,
                width: 70,
            },
            {
                headerName: "Tipo",
                field: "descricaoTipoAlarme",
                type: "string",
                width: 180,
            },
            {
                headerName: "Usuário",
                field: "nomeUsuario",
                type: "string",
                flex: 1,
            },
            {
                headerName: "Usuários ocultos",
                field: "usuariosOcultos",
                type: "string",
                flex: 1,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    const usuariosOcultosOptions = [
        { label: "Todos", value: "Todos" },
        { label: "Sim", value: "Sim" },
        { label: "Não", value: "Não" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceGrupoAlarme
            .getWithFilter({
                ...filters,
                take: pageSize,
                currentPage: page + 1,
                sortExpression: sortModel[0]?.field ?? "",
                sortDirection: sortModel[0]?.sort ?? "",
            })
            .then((result) => {
                if (result) {
                    setData(result?.data.content);
                    setRowCount(result?.data.numberOfElements);
                }
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    useEffect(() => {
        setDataUsers();
        setDataTipo();
    }, []);

    const setDataUsers = () => {
        serviceUsuario
            .getWithFilter({ take: 99999 })
            .then((result) => {
                if (result) {
                    const newArray = result?.data.content.map((item) => {
                        return { value: item.usuarioID, label: item.nome };
                    });
                    setUsersDataOptions(newArray);
                }
            })
            .catch(() => {
                setUsersDataOptions([]);
            });
    };

    const setDataTipo = () => {
        serviceGrupoAlarme
            .getAllTipoAlarme(null)
            .then((result) => {
                if (result) {
                    setTipoDataOptions(result.data);
                }
            })
            .catch(() => {
                setTipoDataOptions([]);
            });
    };

    const handleDelete = async () => {
        serviceGrupoAlarme
            .delete(exclusionState.data)
            .then((result) => {
                if (result) {
                    toast.success(messages.deleteSucess);
                }
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionState({ data: "", open: false });
                getAllWithFilters(filters);
            });
    };

    const handleClickOpenNew = () => {
        setOpenNew(true);
    };

    const handleCloseNew = () => {
        setOpenNew(false);
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipoAlarme: values.tipoAlarme === "Todos" ? "" : values.tipoAlarme,
            usuariosOcultos: values.usuariosOcultos === "Todos" ? "" : values.usuariosOcultos,
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    const onClear = () => {
        reset();
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={2}>
                                            <AutoComplete
                                                name="tipoAlarmeID"
                                                label="Tipo"
                                                options={tipoDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <AutoComplete
                                                name="usuarioID"
                                                label="Usuário"
                                                options={usersDataOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <AutoComplete
                                                name="usuariosOcultos"
                                                label="Usuários ocultos"
                                                options={usuariosOcultosOptions}
                                                control={control}
                                                error={errors}
                                            />
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="contained"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Search />}
                                                type="submit"
                                                disabled={isLoading}
                                            >
                                                Pesquisar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                disableElevation
                                                variant="outlined"
                                                color="warning"
                                                fullWidth
                                                style={{ margin: "16px 0px 8px 0px" }}
                                                startIcon={<Clear />}
                                                onClick={() => onClear()}
                                            >
                                                Limpar
                                            </Button>
                                        </Grid>

                                        <Grid item md={2}>
                                            <Button
                                                style={{ marginTop: 16, marginBottom: 8 }}
                                                variant="contained"
                                                color="primary"
                                                startIcon={<AddCircle />}
                                                onClick={handleClickOpenNew}
                                                disableElevation
                                                fullWidth
                                                size="medium"
                                            >
                                                Novo
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.grupoAlarmeID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <ConfirmationDialog
                        open={exclusionState?.open}
                        title={"Excluir"}
                        message={messages.deleteConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setExclusionState({ data: "", open: false })}
                        onCancel={() => setExclusionState({ data: "", open: false })}
                        onConfirm={() => {
                            setExclusionState({ data: "", open: false });
                            handleDelete();
                        }}
                    />

                    <DialogNew
                        open={openNew}
                        onSuccess={() => onSuccessAction()}
                        onClose={() => {
                            handleCloseNew();
                        }}
                    />
                </CardContent>
            </Card>
        </Container>
    );
};

export default GrupoAlarme;
